import React, { useState, useEffect } from "react";

export default function TimelinePlayer({ frames = [], onFrameChange, onReset,  setIsAnimationMode, currentFrame }) {

  const [isPlaying, setIsPlaying] = useState(false);
  const [index, setIndex] = useState(0);

  // --- Reset index if frames change ---
  useEffect(() => {
    if (!frames || frames.length === 0) {
      setIndex(0);
      return;
    }
    if (index >= frames.length) {
      setIndex(0);
    }
  }, [frames]);

  // --- Play animation ---
  useEffect(() => {
    if (!isPlaying) return;
    if (!frames || frames.length === 0) return;

    const id = setInterval(() => {
      setIndex(prev => {
        const next = (prev + 1) % frames.length;
        const f = frames[next];

        if (f && onFrameChange) {
          onFrameChange(f, f.key || "");
        }

        return next;
      });
    }, 450);

    return () => clearInterval(id);
  }, [isPlaying, frames, onFrameChange]);
  
  useEffect(function () {

      if (!setIsAnimationMode) {
          return;
      }

      setIsAnimationMode(
          isPlaying
      );

  }, [
      isPlaying,
      setIsAnimationMode
  ]);
  
  
  useEffect(function () {

      if (
          !currentFrame
          || !frames
          || frames.length === 0
      ) {
          return;
      }

      const idx =
          frames.findIndex(function (f) {

              return (
                  f.key === currentFrame.key
              );

          });

      if (idx >= 0) {

          setIndex(idx);
      }

  }, [
      currentFrame,
      frames
  ]);

  // --- Manual slider change ---
  function handleChange(e) {
    const newIndex = Number(e.target.value);
    setIndex(newIndex);

    const f = frames[newIndex];
    if (f && onFrameChange) {
      onFrameChange(f, f.key || "");
    }
  }

  // --- Reset to overview ---
  function handleReset() {
    setIsPlaying(false);
    setIndex(0);

    if (onReset) {
      onReset();
    }
  }

  // --- If no frames yet, render safe fallback ---
  if (!frames || frames.length === 0) {
    return (
      <div style={styles.panel}>
        <div style={{ color: "#888" }}>Loading…</div>
      </div>
    );
  }

  return (
    <div style={styles.panel}>

      {/* Play / Pause */}
      <button
        style={styles.play}
        onClick={() => setIsPlaying(!isPlaying)}
        title={isPlaying ? "Pause" : "Play"}
      >
        {isPlaying ? "❚❚" : "▶"}
      </button>

      {/* Reset */}
      <button
        style={styles.reset}
        onClick={handleReset}
        title="Reset to survey average"
      >
        ↺
      </button>

      {/* Slider */}
      <input
        type="range"
        min="0"
        max={frames.length - 1}
        value={index}
        onChange={handleChange}
        style={styles.slider}
      />

      <div style={styles.counter}>
        {index + 1}/{frames.length}
      </div>
    </div>
  );
}

const styles = {

    panel: {

        flex:
            1,

        height:
            "56px",

        display:
            "flex",

        alignItems:
            "center",

        gap:
            "14px",

        padding:
            "0px 20px",

        borderRadius:
            "0px",

        background:
            "linear-gradient(180deg,#171b20 0%,#0c0f12 100%)",

        boxShadow:
            "0 8px 20px rgba(0,0,0,0.22)",

        border:
            "1px solid rgba(255,255,255,0.08)",

        borderBottom:
            "2px solid #20afe8",

        color:
            "white"

    },

    play: {

        width:
            "42px",

        height:
            "42px",

        borderRadius:
            "0px",

        border:
            "1px solid rgba(255,255,255,0.12)",

        background:
            "rgba(255,255,255,0.07)",

        color:
            "#ffffff",

        fontSize:
            "18px",

        cursor:
            "pointer",

        boxShadow:
            "0 3px 10px rgba(0,0,0,0.16)"

    },

    reset: {

        width:
            "42px",

        height:
            "42px",

        borderRadius:
            "0px",

        border:
            "1px solid rgba(255,255,255,0.10)",

        background:
            "rgba(255,255,255,0.035)",

        color:
            "rgba(255,255,255,0.68)",

        fontSize:
            "18px",

        cursor:
            "pointer",

        boxShadow:
            "0 3px 10px rgba(0,0,0,0.14)"

    },

    slider: {

        flex:
            1,

        height:
            "6px",

        accentColor:
            "#20afe8",

        cursor:
            "pointer"

    },

    counter: {

        minWidth:
            "70px",

        textAlign:
            "right",

        color:
            "rgba(255,255,255,0.82)",

        fontSize:
            "14px",

        fontWeight:
            500

    }

};
